import { render, staticRenderFns } from "./customModel.vue?vue&type=template&id=deb520d4&scoped=true"
import script from "./customModel.vue?vue&type=script&lang=js"
export * from "./customModel.vue?vue&type=script&lang=js"
import style0 from "./customModel.vue?vue&type=style&index=0&id=deb520d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb520d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deb520d4')) {
      api.createRecord('deb520d4', component.options)
    } else {
      api.reload('deb520d4', component.options)
    }
    module.hot.accept("./customModel.vue?vue&type=template&id=deb520d4&scoped=true", function () {
      api.rerender('deb520d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/components/customModel.vue"
export default component.exports